const roles = {
  1: 'Admin',
  2: 'Content management and reporting',
  3: 'Content approver and publisher',
};
Object.freeze(roles);

const apiUrlPrefix = '/api/web/';
const storagePath = '/storage/';

export { roles, apiUrlPrefix, storagePath };
